import React, { useEffect, useRef, useState } from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { Box, Grid, Typography } from '@mui/material';
import { saveAs } from 'file-saver';
import { StyledButton } from '@/components/styled/button';

const UXResearchShape = ({ scores, design, jsonData, submissionId }: any) => {
  ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
    {
      id: 'custom_canvas_background_color',
      beforeDraw: (chart) => {
        const ctx = chart.canvas.getContext('2d');
        ctx!.save();
        ctx!.globalCompositeOperation = 'destination-over';
        ctx!.fillStyle = '#000000';
        ctx!.fillRect(0, 0, chart.width, chart.height);
        ctx!.restore();
      },
    }
  );
  const [copied, setCopied] = useState(false);
  const saveChart = () => {
    //save to png
    const canvasSave = document.getElementById('ux-research-shape-chart');
    // @ts-ignore: Object is possibly 'null'.
    canvasSave.toBlob(function (blob) {
      saveAs(blob, 'ux-research-shape-chart.png');
    });
  };

  const handleCopyChartUrl = (): void => {
    let shareUrl: string = window.location.href;
    if (submissionId && shareUrl.slice(-6) !== submissionId) {
      shareUrl += `/submission/${submissionId}`;
    }

    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };
  const chartData = {
    labels: jsonData.chartCategories,
    datasets: [
      {
        label: 'Shape',
        data: scores,
        backgroundColor: 'rgba(134, 188, 37, 0.2)',
        borderColor: 'rgba(134, 188, 37, 1)',
        borderWidth: 1,
      },
    ],
  };
  const chartOptions: {
    plugins: {
      legend: any;
    };
    scales: {
      r: {
        min: number;
        max: number;
        ticks: {
          stepSize: number;
          callback: any;
        };
        grid: {
          color: string;
          lineWidth: number;
        };
        pointLabels: any;
      };
    };
  } = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        min: 0,
        max: 3,
        ticks: {
          stepSize: 1,
          callback: function (index: number): string {
            switch (index) {
              case 1:
                return 'Learning';
              case 2:
                return 'Experienced';
              case 3:
                return 'Expert';
              default:
                return '';
            }
          },
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.75)',
          lineWidth: 2,
        },
        pointLabels: {
          /* Adjust data label font size according to chart size */
          font: function (context: { chart: { width: any } }) {
            var width = context.chart.width;
            var size = Math.round(width / 48);
            return {
              size: size,
            };
          },
          color: 'rgba(255, 255, 255, 1)',
        },
      },
    },
  };

  return (
    <div
      className='main-end-page-wrapper'
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
        sx={{
          marginTop: ['20vh', '12.5vh'], // calc(113px + 2vh)
          padding: '0 5%',
          width: '100%',
        }}
      >
        <Grid item>
          <Typography variant='h5' color='white' textAlign='center'>
            Thank you for completing the<br></br>UX Research Shape Assessment
          </Typography>
        </Grid>
        <Grid item width={['100%', '85%', 650]}>
          <Box>
            <Radar
              id='ux-research-shape-chart'
              data={chartData}
              options={chartOptions}
            />
          </Box>
        </Grid>
        <Grid item sx={{ marginBottom: '50px' }}>
          <StyledButton
            background={design.colors.button}
            $buttonColor={design.colors.buttonText}
            highlight={design.colors.buttonActive}
            className={'save-button'}
            onClick={saveChart}
            sx={{ width: '300px', display: 'flex', marginTop: '20px' }}
          >
            SAVE SHAPE
          </StyledButton>
          {copied && (
            <div
              style={{
                color: 'rgba(134, 188, 37, 1)',
                fontWeight: 'bold',
                marginBottom: '5px',
                textAlign: 'center',
              }}
            >
              Copied to clipboard!
            </div>
          )}
          <StyledButton
            background={design.colors.button}
            $buttonColor={design.colors.buttonText}
            highlight={design.colors.buttonActive}
            className={'share-button'}
            onClick={handleCopyChartUrl}
            sx={{ width: '300px', top: '10px' }}
          >
            SHARE
          </StyledButton>
        </Grid>
      </Grid>
    </div>
  );
};

export default UXResearchShape;
